import { isCodeChild } from '../isCodeChild/isCodeChild'

import type { LanguageType } from '@shared/ui/lib/components/Code/languages'

/**
 * Extracts the language from a code block.
 * @param props - The props of the code block.
 * @returns The language of the code block.
 */
export const extractLanguage = (props: {
  children: unknown
}): LanguageType | null => {
  const { children } = props
  if (isCodeChild(children)) {
    const className = children.props.className || ''
    const lang = className.replace('language-', '') as LanguageType | ''

    return lang || null
  }
  return null
}
